const router = [
  {
    path: "/kelola/instansi/:instansi_id/kelas",
    name: "kelas",
    meta: {
      auth: true,
      module: "Kelola Kelas"
    },
    component: () => import("./pages/List.vue")
  },
  {
    path: "/kelola/instansi:instansi_id/diklat/:diklat_id/kelas/:kelas_id",
    name: "kelas.detail",
    meta: {
      module: "Detail Kelas",
      auth: true
    },
    component: () => import("./pages/Detail.vue")
  },
  {
    path: "/kelola/instansi/:instansi_id/verval/:kelas_id",
    name: "peserta.verval",
    meta: {
      auth: true,
      module: "Verval Peserta Kelas"
    },
    component: () => import("./pages/Verval.vue")
  },
];

export default router;
